import React from 'react';
import { Check } from '@onward-delivery/design/icons';

/**
 * A read-only on/off setting: a round check beside its label, green when on and grey when off.
 * Screen readers hear the state as "On" or "Off".
 * @param {{ checked: boolean, label: React.ReactNode }} props
 */
const CheckOption = ({ checked, label }) => (
    <div className="flex min-w-0 items-center gap-5">
        <span
            role="img"
            aria-label={checked ? 'On' : 'Off'}
            className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-white ${
                checked ? 'bg-primary' : 'bg-muted/60'
            }`}
        >
            <Check aria-hidden="true" className="h-4 w-4" strokeWidth={3} />
        </span>
        <span className="min-w-0 flex-1 break-words text-base text-foreground">{label}</span>
    </div>
);

export default CheckOption;
